import DefaultLayout from '../../layout/DefaultLayout';
import InventoryStockTableSection from '../../components/inventory/stock/InventoryStockTableSection';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

const InventoryStock = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />
      <InventoryStockTableSection />
    </DefaultLayout>
  );
};

export default InventoryStock;
